import type { Bootstrap, Credits, SourceId } from '@/data-sources/contract';
import { api, overrideExisting } from '@/store/api/api';
import { fromSource, type Sourced } from '@/store/api/fromSource';
import { tag } from '@/store/api/tags';

export const bootstrapApi = api.injectEndpoints({
  overrideExisting,
  endpoints: (build) => ({
    bootstrap: build.query<Bootstrap, Sourced<void>>({
      queryFn: fromSource((source, _params, ctx) => source.bootstrap(ctx)),
      providesTags: (_r, _e, arg) => [tag('Bootstrap', arg.source)],
      keepUnusedDataFor: Infinity,
    }),
    credits: build.query<Credits, Sourced<void>>({
      queryFn: fromSource((source, _params, ctx) => source.credits(ctx)),
      providesTags: (_r, _e, arg) => [tag('Credits', arg.source)],
    }),
  }),
});

export const sourcedArg = (source: SourceId): Sourced<void> => ({ source, params: undefined });
